import { useState, useEffect } from "react";

import API from "utils/api";
import { anyToHash } from "utils/misc";
import { useUser } from "utils/hooks";

export default function useFavorites(contentType, filters) {
  const { token } = useUser();
  const [type, setType] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchFavorites() {
      setLoading(true);
      setResult(null);
      setType(contentType);

      const { response, data } = await API.fetchFavorites(token, contentType, filters);

      if (response.ok) {
        setResult(data);
      }
      
      setLoading(false);
    }

    if (contentType !== null) {
      fetchFavorites();
    }
  }, [contentType, anyToHash(filters)]);

  return {
    loading,
    type,
    results: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
